import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Team } from '@app/shared/models/team';
import { CreateTeamDropboxOutput } from '@smash-sdk-private/transfer/01-2024';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-dropbox-summary',
  templateUrl: './dropbox-summary.component.html',
  styleUrls: ['./dropbox-summary.component.scss'],
  animations: [
    trigger(
      'fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('800ms', style({ opacity: '1' }))
      ]),
    ]
    )
  ],
})
export class DropboxSummaryComponent implements OnInit {

  @Input() dropbox: CreateTeamDropboxOutput['dropbox'];
  @Input() hasPromotion: boolean;
  @Input() showDiscoverSmash: boolean;
  @Input() showMyAccount: boolean;
  @Input() selectedTeam: Team;

  @Output() smashAgainClicked: EventEmitter<boolean> = new EventEmitter();

  dropboxUrlCopied = false;
  fadeOut = false;
  menuExpanded = false;

  constructor(private clipboardService: ClipboardService) { }

  ngOnInit() { }

  onCopy() {
    this.dropboxUrlCopied = true;
    this.fadeOut = true;
    setTimeout(() => this.dropboxUrlCopied = false, 1500);
    setTimeout(() => this.fadeOut = false, 400);
  }

  get link() {
    return `${window.location.origin}/request/${this.dropbox.id}`;
  }

  copyLink() {
    this.clipboardService.copy(this.link);
    this.onCopy();
  }

  makeNewDropbox() {
    this.smashAgainClicked.emit(true);
  }

  expandMenu() {
    this.menuExpanded = !this.menuExpanded;
  }
}
